module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": "/customer/account/index"
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("message.reset_password")))])], 1)]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.correctmsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "correct-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.correctmsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list-block customer-login "
  }, [(_vm.resetPasswordActive && _vm.loadSuccess) ? _c('div', {
    staticClass: "account-create"
  }, [_c('div', {
    attrs: {
      "method": "post",
      "id": "form-validate"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input-text validate-email required-entry",
    attrs: {
      "placeholder": "Your Email Address",
      "name": "editForm[email]",
      "id": "email_address",
      "title": "Email Address",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "input-text required-entry validate-password",
    attrs: {
      "placeholder": "New password",
      "name": "editForm[password]",
      "id": "password",
      "title": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "input-text required-entry validate-cpassword",
    attrs: {
      "placeholder": "Confirm Password",
      "name": "editForm[confirmation]",
      "title": "Confirm Password",
      "id": "confirmation",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons-set"
  }, [_c('p', [_c('a', {
    staticClass: "button button-fill",
    attrs: {
      "external": "",
      "href": "javascript:void(0)",
      "id": "js_resetPassBtn"
    },
    on: {
      "click": function($event) {
        return _vm.submitResetPassword()
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("message.reset_password")) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.resetPasswordActive && _vm.loadSuccess) ? _c('div', {
    staticClass: "customer-forgot-success"
  }, [_vm._v("\n                Your Reset Password Token is Expired, \n                You can \n                "), _c('router-link', {
    attrs: {
      "to": "/customer/account/forgotpassword"
    }
  }, [_vm._v("\n                    click here\n                ")]), _vm._v("\n                to retrieve it\n            ")], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f982ce9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/account/Resetpassword.vue
// module id = 258
// module chunks = 1